import { WEEK_HIGH_LOW, WEEK_HIGH_LOW_STREAM, } from "../../../interface/iWeekHighLow";
import { drivingMarketStreamingUpdate, } from "@domains/features/Markets/Equity/utils/streamingUpdate";
let initState = {
    data: [],
};
const weekHighLow = (state = initState, action) => {
    switch (action.type) {
        case WEEK_HIGH_LOW:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case WEEK_HIGH_LOW_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketStreamingUpdate(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default weekHighLow;
